import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base';
import { MatSnackBar } from '@angular/material/snack-bar'; 
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../models/base';

const FACTURASIA_ENDPOINT = '/';

@Injectable({ providedIn: 'root' })
export class SubscriptionsService extends BaseService {
  constructor(
    private httpClient: HttpClient,
    protected snackBar: MatSnackBar
  ) {
    super(snackBar);
  }

  /**
   * Comprueba la suscripción de IA.
   * @returns Un Observable que emite un valor booleano indicando si la suscripción de IA está activa.
   */
  checkSubscriptionIA(): Observable<boolean> {
    return this.httpClient
      .get<ApiResponse<boolean>>(`${environment.apiUrl}${FACTURASIA_ENDPOINT}CheckSubscriptionIA`)
      .pipe(
        map((data: ApiResponse<boolean>) => {
          if (data != null && data.data != null) {
            return !!data.data;
          }

          if (data && data.error) {
            this.procesarError(data);
          }

          return false;
        }),
        catchError((error) => {
          this.procesarError(error);
          return throwError(error);
        })
      );
  }
}